import { render, staticRenderFns } from "./DetailContractManager.vue?vue&type=template&id=1d305b1a&scoped=true&"
import script from "./DetailContractManager.vue?vue&type=script&lang=js&"
export * from "./DetailContractManager.vue?vue&type=script&lang=js&"
import style0 from "./DetailContractManager.vue?vue&type=style&index=0&id=1d305b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d305b1a",
  null
  
)

export default component.exports